import { DataService } from "@/services/data";
import { MROffice } from "@/types/medrep/office";
import { handle_error } from "@/utils/wretch";
import { RouteObject, defer, json, redirect } from "react-router-dom";
import { toast } from "sonner";

const OfficeRoute: RouteObject = {
    path: "cabinets",
    children: [
        {
            index: true,
            // async lazy() {
            //     let { ListPage } = await import("@/pages/medrep/candidate/list");
            //     return { Component: ListPage };
            // },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                const offices = DataService.client
                    .url(`/medrep/offices/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return defer({ offices });
            }
        },
        {
            path: "nouveau",
            action: async ({ request }) => {
                const data = await request.json();

                try {
                    const office = (await DataService.client.url(`/medrep/offices/new/`).post(data).json()) as MROffice;
                    toast.success("Le dossier a été créé");
                    return redirect(`/alternance/candidats/${office.id}`);
                } catch (error) {
                    toast.error("Une erreur est survenue lors de la création du dossier");
                }
                return redirect("..");
            }
        },
        {
            path: "carte",
            // async lazy() {
            //     let { MapPage } = await import("@/pages/medrep/candidate/map");
            //     return { Component: MapPage };
            // },
            loader: async () => {
                const offices = DataService.client.url(`/medrep/offices/map/`).get().json();
                const companies = DataService.client.url(`/medrep/companies/map/`).get().json();
                const offer_ads = DataService.client.url(`/medrep/offer_ads/map/`).get().json();
                // const department_assignations = DataService.client.url(`/medrep/department_assignations/?page_size=250`).get().json();
                return { offices, companies, offer_ads };
            }
        },
        {
            id: "medrep-office-detail",
            path: ":contactId",
            // async lazy() {
            //     let { DetailLayout } = await import("@/pages/medrep/candidate/detail-layout");
            //     return { Component: DetailLayout };
            // },
            loader: async ({ params }) => {
                const contactId = params.contactId;
                const office = (await DataService.client.url(`/medrep/offices/${contactId}`).get().json()) as MROffice;
                return defer({ office });
            },
            action: async ({ params, request }) => {
                const contactId = params.contactId;
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client.url(`/medrep/offices/${contactId}/${action}/`).post(data).json();
                        return json({ success: true, content: content });
                    } catch (error) {
                        return handle_error(error);
                    }
                }
                return {};
            }
        }
    ]
};

export default OfficeRoute;
